<template>
  <body>
    <Header></Header>
    <img src="rating.png" class="logo" height="50px" width="50px" />
    <span class="title">Rating Distribution</span>
    <div class="Intro">
      <div class="Intro-title">Sunburst Chart</div>
      <div class="Intro-explain">
        The sunburst chart is ideal for displaying hierarchical data. Each level
        of the hierarchy is represented by one ring or circle with the innermost
        circle as the top of the hierarchy. The radial orientation of the
        sunburst chart utilizes space more efficiently compared to the linear
        (horizontal or vertical) hierarchical visualization.
      </div>
    </div>

    <div class="Intro2">
      <div class="Intro-title">Rating Distribution of Netflix Content</div>
      <div class="Intro-explain">
        In this sunburst chart, we want to show the rating distribution of
        Netflix produced content. The user can view the number of rating
        contents in different audience types, in different content types(movie
        or tv) and in different years. And we have a tree structure to show the
        hierarchy layout of the sunburst chart.
      </div>
    </div>

    <div class="tree">
      <div class="race_title">
        Tree Structure To Explain Sunburst Chart Hierarchy
      </div>
      <div class="tree_chart">
        <svg id="tree_chart" width="1000" height="400"></svg>
      </div>
    </div>

    <div class="race">
      <div class="race_title">Rating Distribution Of Netflix Content</div>

      <div
        style="
          position: absolute;
          color: rgba(255, 255, 255, 0.93);
          left: 65%;
          top: 15%;
          font-size: 20px;
        "
      >
        G, TV-Y, TV-G
      </div>
      <div
        style="
          position: absolute;
          background: rgba(255, 255, 255, 0.8);
          left: 65%;
          top: 19.5%;
          width: 120px;
          height: 1px;
        "
      ></div>
      <div
        style="
          position: absolute;
          color: rgba(255, 255, 255, 0.7);
          left: 65%;
          top: 21%;
          font-size: 15px;
          padding-right:5px;
        "
      >
        All ages admitted. Nothing that would offend parents for viewing by
        children.
      </div>

      <div
        style="
          position: absolute;
          color: rgba(255, 255, 255, 0.93);
          left: 65%;
          top: 33%;
          font-size: 20px;
        "
      >
        PG, TV-Y7, TV-Y7-FV, TV-PG
      </div>
      <div
        style="
          position: absolute;
          background: rgba(255, 255, 255, 0.8);
          left: 65%;
          top: 37.5%;
          width: 250px;
          height: 1px;
        "
      ></div>
      <div
        style="
          position: absolute;
          color: rgba(255, 255, 255, 0.7);
          left: 65%;
          top: 38%;
          font-size: 15px;
          padding-right:5px;
        "
      >
        Parents urged to give "parental guidance". May contain some material
        parents might not like for their young children.
      </div>

      <div
        style="
          position: absolute;
          color: rgba(255, 255, 255, 0.93);
          left: 65%;
          top: 55%;
          font-size: 20px;
        "
      >
        PG-13, TV-14
      </div>
      <div
        style="
          position: absolute;
          background: rgba(255, 255, 255, 0.8);
          left: 65%;
          top: 59.5%;
          width: 120px;
          height: 1px;
        "
      ></div>
      <div
        style="
          position: absolute;
          color: rgba(255, 255, 255, 0.7);
          left: 65%;
          top: 60%;
          font-size: 15px;
          padding-right:5px;
        "
      >
        Parents are urged to be cautious. Some material may be inappropriate for
        pre-teenagers.
      </div>

      <div
        style="
          position: absolute;
          color: rgba(255, 255, 255, 0.93);
          left: 65%;
          top: 75%;
          font-size: 20px;
        "
      >
        R, NC-17, TV-MA
      </div>
      <div
        style="
          position: absolute;
          background: rgba(255, 255, 255, 0.8);
          left: 65%;
          top: 79.5%;
          width: 150px;
          height: 1px;
        "
      ></div>
      <div
        style="
          position: absolute;
          color: rgba(255, 255, 255, 0.7);
          left: 65%;
          top: 80%;
          font-size: 15px;
          padding-right:5px;
        "
      >
        Contains adult material. Young children may not be admitted to watch
        some films or TVs under these ratings.
      </div>

      <div class="sunburst_chart">
        <svg id="chart" width="550" height="550"></svg>
      </div>
    </div>

    <router-link to="/cloud" @click.native="scrollToTop">
      <div class="next">
        <img src="next.png" height="50px" width="50px" />
      </div>
    </router-link>
  </body>
</template>

<script>
import * as d3 from "d3";
import Header from "@/components/Header";
export default {
  name: "sunburst",
  components: {
    Header,
  },
  data: function () {
    return {
      sunburst_data: null,
      tree_data: null,
    };
  },
  mounted: function () {
    console.log("mounted");

    if (!this.$store.state.sunburst_data) {
      d3.json("netflix_suburst.json").then((data) => {
        this.sunburst_data = data;
        // console.log("chartData set from file");
        // console.log("chartData contains", this.chartData.length, "rows");
        this.$store.commit("sunburst_data", this.sunburst_data);

        this.sunburst();
      });
    } else {
      this.sunburst_data = this.$store.state.sunburst_data;
      //console.log("chartData set from store");
      //console.log("chartData contains", this.sunburst_data.length, "rows");
      this.sunburst();
    }

    if (!this.$store.state.tree_data) {
      d3.json("tree.json").then((data) => {
        this.tree_data = data;
        // console.log("chartData set from file");
        // console.log("chartData contains", this.chartData.length, "rows");
        this.$store.commit("tree_data", this.tree_data);

        this.tree();
      });
    } else {
      this.tree_data = this.$store.state.tree_data;
      //console.log("chartData set from store");
      //console.log("chartData contains", this.sunburst_data.length, "rows");
      this.tree();
    }
  },
  methods: {
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    /* eslint-disable */
    tree() {
      var data=this.tree_data
      var tree = (data) => {
        const root = d3.hierarchy(data);
        root.dx = 20;
        root.dy = width / (root.height + 1) + 70;
        return d3.tree().nodeSize([root.dx, root.dy])(root);
      };
      var width = 500;

      const root = tree(data);

      let x0 = Infinity;
      let x1 = -x0;
      root.each((d) => {
        if (d.x > x1) x1 = d.x;
        if (d.x < x0) x0 = d.x;
      });

      const svg = d3.select("#tree_chart");
      //.attr("viewBox", [0, 0, width, x1 - x0 + root.dx * 2]);

      const g = svg
        .append("g")
        //.attr("font-family", "sans-serif")
        .attr("font-size", 10)
        .attr(
          "transform",
          `translate(${root.dy / 3 + 30},${root.dx - x0 + 10})`
        );

      const link = g
        .append("g")
        .attr("fill", "none")
        .attr("stroke", "rgb(255,255,255,0.5)")
        //.attr("stroke-opacity", 0.4)
        .attr("stroke-width", 1)
        .selectAll("path")
        .data(root.links())
        .join("path")
        .attr(
          "d",
          d3
            .linkHorizontal()
            .x((d) => d.y)
            .y((d) => d.x)
        );

      const node = g
        .append("g")
        //.attr("stroke-linejoin", "round")
        //.attr("stroke-width", 3)
        .selectAll("g")
        .data(root.descendants())
        .join("g")
        .attr("transform", (d) => `translate(${d.y},${d.x})`);

      node
        .append("circle")
        .attr("fill", (d) =>
          d.children ? "rgb(255,255,255,0.5)" : "rgb(255,255,255,0.8)"
        )
        .attr("r", 2.5);

      node
        .append("text")
        .attr("dy", function (d) {
          if (
            d.data.name == "Years (4 parts)" ||
            d.data.name == "Movie or TV Show" ||
            d.data.name == "Audience"
          ) {
            return "-0.2em";
          } else {
            return "0.31em";
          }
        })
        //.attr('dy',d => d.children ? "0.1em" : "0.31em")
        .attr("x", (d) => (d.children ? -6 : 6))
        .attr("text-anchor", (d) => (d.children ? "end" : "start"))
        .style("fill", "rgb(255,255,255,0.9)")

        .text((d) => d.data.name);
      //.clone(true).lower();
    },
    sunburst() {
      //console.log(this.sunburst_data)
      var data = this.sunburst_data;
      var partition = (data) => {
        const root = d3
          .hierarchy(data)
          .sum((d) => d.value)
          .sort((a, b) => b.value - a.value);
        return d3.partition().size([2 * Math.PI, root.height + 1])(root);
      };

      var format = d3.format(",d");
      var width = 550;
      var radius = width / 6;
      var arc = d3
        .arc()
        .startAngle((d) => d.x0)
        .endAngle((d) => d.x1)
        .padAngle((d) => Math.min((d.x1 - d.x0) / 2, 0.005))
        .padRadius(radius * 1.5)
        .innerRadius((d) => d.y0 * radius)
        .outerRadius((d) => Math.max(d.y0 * radius, d.y1 * radius - 1));

      const root = partition(data);

      root.each((d) => (d.current = d));

      const svg = d3
        .select("#chart")
        .attr("transform", "translate(50,0)")
        //.attr("viewBox", [0, 0, width, width])
        .style("font", "10px sans-serif");

      var color = d3.scaleOrdinal(
        d3.quantize(d3.interpolateRainbow, data.children.length + 1)
      );

      const g = svg
        .append("g")
        .attr("transform", `translate(${width / 2},${width / 2})`);

      const path = g
        .append("g")
        .selectAll("path")
        .data(root.descendants().slice(1))
        .join("path")
        .attr("fill", (d) => {
          while (d.depth > 1) d = d.parent;
          return d3.rgb(color(d.data.name)).brighter(1.7);
          // return color(d.data.name).h+=90
        })
        // .attr('opacity','0.7')
        .attr("fill-opacity", (d) =>
          arcVisible(d.current) ? (d.children ? 0.6 : 0.4) : 0
        )
        .attr("d", (d) => arc(d.current));

      path
        .filter((d) => d.children)
        .style("cursor", "pointer")
        .on("click", clicked);

      path.append("title").text(
        (d) =>
          `${d
            .ancestors()
            .map((d) => d.data.name)
            .reverse()
            .join("/")}\n${format(d.value)}`
      );

      const label = g
        .append("g")
        .attr("pointer-events", "none")
        .attr("text-anchor", "middle")
        .style("user-select", "none")
        .selectAll("text")
        .data(root.descendants().slice(1))
        .join("text")
        .attr("dy", "0.35em")
        .attr("fill-opacity", (d) => +labelVisible(d.current))
        .attr("transform", (d) => labelTransform(d.current))
        .attr("fill", "rgba(255, 255, 255, 0.815)")
        .text((d) => d.data.name);

      const parent = g
        .append("circle")
        .datum(root)
        .attr("r", radius)
        .attr("fill", "none")
        .attr("pointer-events", "all")
        .on("click", clicked);

      function clicked(event, p) {
        parent.datum(p.parent || root);

        root.each(
          (d) =>
            (d.target = {
              x0:
                Math.max(0, Math.min(1, (d.x0 - p.x0) / (p.x1 - p.x0))) *
                2 *
                Math.PI,
              x1:
                Math.max(0, Math.min(1, (d.x1 - p.x0) / (p.x1 - p.x0))) *
                2 *
                Math.PI,
              y0: Math.max(0, d.y0 - p.depth),
              y1: Math.max(0, d.y1 - p.depth),
            })
        );

        const t = g.transition().duration(750);

        // Transition the data on all arcs, even the ones that aren’t visible,
        // so that if this transition is interrupted, entering arcs will start
        // the next transition from the desired position.
        path
          .transition(t)
          .tween("data", (d) => {
            const i = d3.interpolate(d.current, d.target);
            return (t) => (d.current = i(t));
          })
          .filter(function (d) {
            return +this.getAttribute("fill-opacity") || arcVisible(d.target);
          })
          .attr("fill-opacity", (d) =>
            arcVisible(d.target) ? (d.children ? 0.6 : 0.4) : 0
          )
          .attrTween("d", (d) => () => arc(d.current));

        label
          .filter(function (d) {
            return +this.getAttribute("fill-opacity") || labelVisible(d.target);
          })
          .transition(t)
          .attr("fill-opacity", (d) => +labelVisible(d.target))
          .attrTween("transform", (d) => () => labelTransform(d.current));
      }

      function arcVisible(d) {
        return d.y1 <= 3 && d.y0 >= 1 && d.x1 > d.x0;
      }

      function labelVisible(d) {
        return d.y1 <= 3 && d.y0 >= 1 && (d.y1 - d.y0) * (d.x1 - d.x0) > 0.03;
      }

      function labelTransform(d) {
        const x = (((d.x0 + d.x1) / 2) * 180) / Math.PI;
        const y = ((d.y0 + d.y1) / 2) * radius;
        return `rotate(${x - 90}) translate(${y},0) rotate(${
          x < 180 ? 0 : 180
        })`;
      }
    },
  },
};
</script>
<style  scoped>
body {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  background: #121212;
  min-height: 245vh;
  width: 100%;
}
.title {
  position: absolute;
  color: rgba(255, 255, 255, 0.781);
  font-size: 25px;
  top: 10%;
  left: 14.5%;
}
.logo {
  position: absolute;
  top: 9%;
  left: 10%;
}
.Intro {
  position: absolute;
  color: rgba(255, 255, 255, 0.93);
  padding: 10px;
  width: 80%;
  height: 20%;
  background: #272727;
  border-radius: 15px;
  top: 20%;
  left: 10%;
  text-align: left;
  overflow: hidden;
}
.Intro2 {
  position: absolute;
  color: rgba(255, 255, 255, 0.93);
  padding: 10px;
  width: 80%;
  height: 20%;
  background: #272727;
  border-radius: 15px;
  top: 45%;
  left: 10%;
  text-align: left;
  overflow: hidden;
}
.Intro-title {
  font-size: 25px;
  margin-left: 2%;
}
.Intro-explain {
  margin-top: 0.5%;
  margin-left: 2%;
  font-size: 15px;
  color: rgba(255, 255, 255, 0.815);
}
.race {
  position: absolute;
  background: #272727;
  width: 80%;
  height: 650px;
  border-radius: 15px;
  top: 135%;
  left: 10%;
  overflow: hidden;
}
.race_title {
  padding: 10px;
  margin-left: 2%;
  color: rgba(255, 255, 255, 0.93);
  font-size: 25px;
}
.button {
  position: absolute;
  top: 2%;
  left: 55%;
}
.button2 {
  position: absolute;
  top: 2%;
  left: 66%;
}
.button3 {
  position: absolute;
  top: 2%;
  left: 77.5%;
}
.sunburst_chart {
  position: absolute;
  left: 1%;
  top: 12%;
  
}
.next {
  position: absolute;
  left: 48%;
  top: 229%;
}
.tree {
  position: absolute;
  background: #272727;
  width: 80%;
  height: 450px;
  border-radius: 15px;
  top: 70%;
  left: 10%;
  overflow: hidden;
}
.tree_chart{
  /* position: absolute; */
  
}
</style>